module.exports = __webpack_public_path__ + "media/images/exp-five-1027cfa4af5559a58e343d7bade84816.png";